import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../../Atoms/Typography'
import GenericRadioSelection from '../GenericRadioSelection'

import theme from '../../../../styles/theme'

const Container = styled(View)`
  padding: ${3 * theme.gutterUnit}px ${3 * theme.gutterUnit}px ${theme.gutterUnit}px ${3 * theme.gutterUnit}px;
  background-color: ${theme.colours.white};
`

const Row = styled(View)`
  flex-direction: row;
  flex-wrap: wrap;
`

const SectionWrapper = styled(View)`
  width: 30%;
`
export default class GameSelection extends PureComponent {
  render () {
    const {
      hostname,
      allGames,
      gameId,
      onGameIdChange
    } = this.props
    const games = allGames[hostname] || []
    return (
      <Container>
        <Text bold>GAME</Text>
        <Row>
          <SectionWrapper>
            <GenericRadioSelection
              boxWidth='300px'
              checkboxes={games.map(g => ({
                handleClick: () => onGameIdChange(g.gameId),
                checked: gameId === g.gameId,
                label: `${g.splashScreenTitle} - ${g.gameName}`
              }))}
            />
          </SectionWrapper>
        </Row>
      </Container>
    )
  }
}
